import React from 'react';
import axios from 'axios';
import LOADER_IMG from './loader.svg';
import style from './styles.css';
import RequisitionsLoader from './RequisitionsLoader';

const Requisitions = (props) => {

  RequisitionsLoader.createLoader();

  axios({
    mode: 'no-cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
    credentials: 'same-origin',
    method: 'post',
    url: props.url,
    data: props.data
  })
  .then(function (response) {
    if(props.sucess){
      props.sucess(response.data);
    }
    RequisitionsLoader.removeLoader();
  })
  .catch(function (error) {
    if(props.error){
      props.error(error);
    }
    RequisitionsLoader.removeLoader();
  });
  // Post a user
}

export const Get = (props) => {
  RequisitionsLoader.createLoader();
  axios.get(props.url)
  .then(function(response){
    if(props.sucess){
      props.sucess(response.data);
    }
    RequisitionsLoader.removeLoader();
  });
}

export default Requisitions;



// WEBPACK FOOTER //
// ./src/utils/requisitions/Requisitions.js